import _defineProperty from "F:/inetpub/cd-next-prod.adfcareers.gov.au/Website/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "F:/inetpub/cd-next-prod.adfcareers.gov.au/Website/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "F:/inetpub/cd-next-prod.adfcareers.gov.au/Website/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["name", "type", "clicked", "hover", "reverse", "onCompleted", "animate"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "F:/inetpub/cd-next-prod.adfcareers.gov.au/Website/node_modules/@babel/runtime/regenerator/index.js";
import React, { useEffect, useId, useLayoutEffect, useRef, useState } from 'react';
import { twJoin, twMerge } from 'tailwind-merge';
import { useIntersect } from 'utils/intersection';
import { useService } from 'utils/useService';
import { useLessThan } from 'utils/useScreen';
import { jsx as _jsx } from "react/jsx-runtime";
// Dynamic importer to load all SVGs as React Components on demand
function useDynamicSVGImport(name) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'fill';
  var isContent = arguments.length > 2 ? arguments[2] : undefined;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var ImportedIconRef = useRef(null);
  var _useState = useState(false),
    setLoading = _useState[1];
  var onCompleted = options.onCompleted;
  var fileName = isContent ? "content/".concat(name) : "".concat(name, "-").concat(type);
  var useIsomorphicLayoutEffect = true ? useLayoutEffect : useEffect;
  useIsomorphicLayoutEffect(function () {
    setLoading(true);
    var importIcon = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var svgModule, page, _ImportedIconRef$curr;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return import("public/icons/svgs/".concat(fileName, ".svg?icon"));
            case 3:
              svgModule = _context.sent;
              ImportedIconRef.current = svgModule.ReactComponent;
              _context.next = 12;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              // Error don't output any svg to page
              page = true ? window.location.pathname : '';
              console.error('Icon load error', name, page, _context.t0);
              setLoading(false);
            case 12:
              _context.prev = 12;
              onCompleted === null || onCompleted === void 0 || onCompleted(name, (_ImportedIconRef$curr = ImportedIconRef.current) !== null && _ImportedIconRef$curr !== void 0 ? _ImportedIconRef$curr : undefined);
              setLoading(false);
              return _context.finish(12);
            case 16:
              setLoading(false);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7, 12, 16]]);
      }));
      return function importIcon() {
        return _ref.apply(this, arguments);
      };
    }();
    importIcon();
  }, [name, type, fileName, onCompleted]);
  return {
    SvgIcon: ImportedIconRef.current
  };
}
// The <Icon /> component
var Icon = function Icon(_ref2) {
  var _rest$width, _rest$height;
  var name = _ref2.name,
    type = _ref2.type,
    _ref2$clicked = _ref2.clicked,
    clicked = _ref2$clicked === void 0 ? false : _ref2$clicked,
    _ref2$hover = _ref2.hover,
    hover = _ref2$hover === void 0 ? false : _ref2$hover,
    _ref2$reverse = _ref2.reverse,
    reverse = _ref2$reverse === void 0 ? false : _ref2$reverse,
    onCompleted = _ref2.onCompleted,
    _ref2$animate = _ref2.animate,
    animate = _ref2$animate === void 0 ? true : _ref2$animate,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var uid = useId();
  var service = useService(rest.service);
  var _useState2 = useState(false),
    active = _useState2[0],
    setActive = _useState2[1];
  var _useState3 = useState(false),
    loaded = _useState3[0],
    setIsLoaded = _useState3[1];
  var isLeeThanMd = useLessThan('md');
  var contentIcon = type === 'content';
  var defaultSize = isLeeThanMd ? 40 : 60;
  var width = (_rest$width = rest.width) !== null && _rest$width !== void 0 ? _rest$width : contentIcon ? defaultSize : 24;
  var height = (_rest$height = rest.height) !== null && _rest$height !== void 0 ? _rest$height : width;
  var className = twMerge('svg-icon', name, contentIcon ? "svg-content transition duration-500 [&_.highlight]:stroke-".concat(service) : 'svg-action', loaded ? 'loaded' : 'loading', reverse && 'reverse', rest.className);
  var _useDynamicSVGImport = useDynamicSVGImport(name, type, contentIcon, {
      onCompleted: onCompleted
    }),
    SvgIcon = _useDynamicSVGImport.SvgIcon;
  useEffect(function () {
    if (SvgIcon) setIsLoaded(true);
  }, [SvgIcon]);
  var handleClick = function handleClick(e) {
    setActive(!active);
    if (name === 'play') {
      var target = e.currentTarget;
      var selector = "#uid".concat(uid.replaceAll(':', '\\:'), " ").concat(target.classList.contains('clicked-active') ? '.animation-to-play' : '.animation-to-pause');
      var animation = target.querySelector(selector);
      animation === null || animation === void 0 || animation.beginElement();
    }
  };
  if (!SvgIcon) {
    return null;
  }
  var action = clicked || hover ? clicked ? 'clicked' : 'hover' : undefined;
  return /*#__PURE__*/_jsx(IconWrapper, {
    id: uid,
    type: type,
    action: action,
    active: active,
    onClick: handleClick,
    animate: animate,
    children: /*#__PURE__*/_jsx(SvgIcon, _objectSpread(_objectSpread({}, rest), {}, {
      className: className,
      width: width,
      height: height
    }))
  });
};
var IconWrapper = function IconWrapper(_ref3) {
  var children = _ref3.children,
    action = _ref3.action,
    active = _ref3.active,
    onClick = _ref3.onClick,
    type = _ref3.type,
    id = _ref3.id,
    animate = _ref3.animate;
  var iconNodeRef = useRef(null);
  var entry = useIntersect(iconNodeRef, '50px 0px -50px');
  return type === 'content' ? /*#__PURE__*/_jsx("div", {
    ref: iconNodeRef,
    className: "self-start ".concat(animate ? "svg-".concat(((entry === null || entry === void 0 ? void 0 : entry.intersectionRatio) || 0) > 0.95 ? 'animated' : 'static') : 'static'),
    "data-entry": entry === null || entry === void 0 ? void 0 : entry.intersectionRatio,
    children: children
  }) : action ? /*#__PURE__*/_jsx("div", {
    id: "uid".concat(id),
    className: twJoin("svg-".concat(action), active && "".concat(action, "-active")),
    onClick: onClick,
    children: children
  }) : children;
};
export default Icon;